import React from "react";
import FullRouter from "./RouterPath/index";
import "bootstrap/dist/css/bootstrap.min.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "./App.css";
import "./Assets/style/style.css";
import SessionTimeoutProvider from "./Pages/SessionTimeoutProvider"; // Import session timeout provider
import { BrowserRouter } from "react-router-dom"; // Keep BrowserRouter only here
import { PermissionProvider } from "./Context/PermissionContext"; // Import the PermissionProvider

const theme = createTheme();

function App() {
  return (
    <>
      <div>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <PermissionProvider>
              <SessionTimeoutProvider>
                <FullRouter />
              </SessionTimeoutProvider>
            </PermissionProvider>
          </BrowserRouter>
        </ThemeProvider>
      </div>
    </>
  );
}

export default App;
